import { create } from 'zustand';
import { idpProvidersApi } from '../lib/apiClient';
import { IdpProviderType, CreateIdpProviderDto, UpdateIdpProviderDto, SafeProvider } from '../types/types';
import { toast } from '../lib/toast';

interface ProvidersState {
  safeProviders: SafeProvider[];
  providers: IdpProviderType[];
  loading: boolean;
  setProviders: (providers: IdpProviderType[]) => void;
  fetchProvidersAdmin: () => Promise<void>;
  fetchProviders: () => Promise<void>;
  createProvider: (data: CreateIdpProviderDto) => Promise<void>;
  updateProvider: (id: string, data: UpdateIdpProviderDto) => Promise<void>;
  deleteProvider: (id: string) => Promise<void>;
}

export const useProvidersStore = create<ProvidersState>((set, get) => ({
  safeProviders: [],
  providers: [],
  loading: false,
  setProviders: (providers: IdpProviderType[]) => set({ providers }),
  fetchProvidersAdmin: async () => {
    set({ loading: true });
    try {
      const result = await idpProvidersApi.listAdmin();
      set({ providers: result.providers || [] });
    } catch (e) {
      set({ providers: [] });
    } finally {
      set({ loading: false });
    }
  },
  fetchProviders: async () => {
    set({ loading: true });
    try {
      const result = await idpProvidersApi.list();
      set({ safeProviders: result.providers || [] });
    } catch (e) {
      set({ safeProviders: [] });
    } finally {
      set({ loading: false });
    }
  },
  createProvider: async (data: CreateIdpProviderDto) => {
    await idpProvidersApi.create(data);
    await get().fetchProviders();
    toast.success('Provider created');
  },
  updateProvider: async (id: string, data: UpdateIdpProviderDto) => {
    await idpProvidersApi.update(id, data);
    await Promise.all([get().fetchProvidersAdmin(), get().fetchProviders()]);
    toast.success('Provider updated');
  },
  deleteProvider: async (id: string) => {
    await idpProvidersApi.delete(id);
    set({ providers: get().providers.filter(p => p.id !== id) });
    toast.success('Provider deleted');
  },
}));
